import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    // loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
        loadChildren: () => import('./main-menu/main-menu.module').then( m => m.MainMenuPageModule)
  },
  {
    path: 'user-view',
    loadChildren: () => import('./user-view/user-view.module').then( m => m.UserViewPageModule)
  },
  {
    path: 'admin-view',
    loadChildren: () => import('./admin-view/admin-view.module').then( m => m.AdminViewPageModule)
  },
  // {
  //   path: 'fmd-screening/:view',
  //   loadChildren: () => import('./fmd-screening/fmd-screening.module').then( m => m.FmdScreeningPageModule)
  // },
  {
    path: 'main-menu',
    loadChildren: () => import('./main-menu/main-menu.module').then( m => m.MainMenuPageModule)
  },
  {
    path: 'conduct-guide',
    loadChildren: () => import('./conduct-guide/conduct-guide.module').then( m => m.ConductGuidePageModule)
  },
  {
    path: 'useful-links',
    loadChildren: () => import('./useful-links/useful-links.module').then( m => m.UsefulLinksPageModule)
  },
  {
    path: 'settings-modal',
    loadChildren: () => import('./settings-modal/settings-modal.module').then( m => m.SettingsModalPageModule)
  },
  {
    path: 'welcome-banner',
    loadChildren: () => import('./welcome-banner/welcome-banner.module').then( m => m.WelcomeBannerPageModule)
  },
  {
    path: 'fmd-status-modal',
    loadChildren: () => import('./fmd-status-modal/fmd-status-modal.module').then( m => m.FmdStatusModalPageModule)
  },
  {
    path: 'faq',
    loadChildren: () => import('./faq/faq.module').then( m => m.FaqPageModule)
  },
  {
    path: 'visitor-submit/:id',
    loadChildren: () => import('./visitor-submit/visitor-submit.module').then( m => m.VisitorSubmitPageModule)
  },
  {
    path: 'visitor-invite',
    loadChildren: () => import('./visitor-invite/visitor-invite.module').then( m => m.VisitorInvitePageModule)
  },
  {
    path: 'tour-submit/:id',
    loadChildren: () => import('./tour-submit/tour-submit.module').then( m => m.TourSubmitPageModule)
  },
];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
